import { render, staticRenderFns } from "./ShopifyItem.vue?vue&type=template&id=0b88aa30"
import script from "./ShopifyItem.vue?vue&type=script&lang=js"
export * from "./ShopifyItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports